import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { Avatar, Box, Paper, Typography, Grid, CircularProgress } from '@mui/material';
import { isEmpty } from 'lodash';
import React, { useRef } from 'react';
import { useMutation, useQuery } from 'react-query';
import IconButton from '../../../components/IconButton';
import { ICON_BUTTON_TYPE } from '../../../constants';
import {
  deleteInstructionsApi,
  getInstructionsApi,
  getUserInstructionsApi,
  deleteUserInstructionsApi,
} from '../../../utils/api';
import AddInstructionsModal from './AddInstructionsModal';
import TopBar from './TopBar';
import ReactPlayer from 'react-player';
import { useTranslation } from 'react-i18next';

const Instructions = ({ user, recipient }) => {
  const { t } = useTranslation();
  const [showAddModal, setShowAddModal] = React.useState(false);
  const [activeEditData, setActiveEditData] = React.useState(null);
  const videoEl = useRef(null);

  const { data, isLoading, refetch } = useQuery(
    ['getInstructionsApi'],
    () =>
      recipient?._id
        ? getInstructionsApi({ userId: user?._id, recipientId: recipient?._id })
        : getUserInstructionsApi({ userId: user?._id }),
    {
      retry: false,
      cacheTime: 0,
    },
  );

  const deleteInstructionsHandler = useMutation(recipient?._id ? deleteInstructionsApi : deleteUserInstructionsApi, {
    onSuccess: async ({ data }) => {
      refetch();
    },
    onError: (error) => {
      console.log('error =====> ', error);
    },
  });

  const handleDelete = (item) => {
    if (recipient?._id) {
      deleteInstructionsHandler.mutate({ userId: user?._id, recipientId: recipient?._id, instructionId: item?._id });
    } else {
      deleteInstructionsHandler.mutate({ userId: user?._id, instructionId: item?._id });
    }
  };

  const handleShowEdit = (item) => {
    setActiveEditData(item);
    setShowAddModal(true);
  };

  return (
    <Grid>
      <TopBar onClick={() => setShowAddModal(true)} btnText={t('addInstruction')} />

      {isLoading && (
        <Grid marginY={10} container justifyContent={'center'}>
          <CircularProgress size={40} style={{ color: '#26786a' }} />
        </Grid>
      )}

      {!isLoading && isEmpty(data?.data) && (
        <Typography variant="h5" textAlign="center">
          {t('noInstructionsFound')}
        </Typography>
      )}

      {!isLoading &&
        !isEmpty(data?.data) &&
        data?.data.map((item, idx) => (
          <Paper
            key={idx}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              p: 2,
              gap: 3,
              backgroundColor: 'collection-1-other-colors-backgrounds-other-bg-container',
              borderRadius: 2,
              mt: 2,
              boxShadow: 'none',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                gap: 6,
                width: '100%',
                '@media (max-width: 600px)': {
                  flexDirection: 'column',
                  gap: 2,
                },
              }}
            >
              <Box
                sx={{
                  width: 250,
                  height: 162,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  // backgroundImage:
                  //   'url(https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRtFY0ugij_y5HdCLZVq3p1SXQmdumlVsSdwg&s)',
                  // backgroundSize: 'cover',
                  borderRadius: 2,
                  '@media (max-width: 600px)': {
                    width: '100%',
                    height: '100%',
                  },
                }}
              >
                <ReactPlayer width="100%" ref={videoEl} controls url={item?.link} height="100%" />
              </Box>

              <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 6 }}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderBottom: '1px solid',
                    borderColor: 'collection-1-other-colors-borders-dividers-other-border',
                    pb: 4,
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      color: 'collection-1-other-colors-text-icons-other-text-lightbg',
                      fontWeight: 500,
                    }}
                  >
                    {item?.title}
                  </Typography>

                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <IconButton type={ICON_BUTTON_TYPE.edit} onClick={() => handleShowEdit(item)} />
                    <IconButton type={ICON_BUTTON_TYPE.delete} onClick={() => handleDelete(item)} />
                  </Box>
                </Box>

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                  <Typography
                    variant="body2"
                    sx={{
                      color: 'collection-1-other-colors-text-icons-other-text-description',
                      fontWeight: 400,
                    }}
                  >
                    {item?.description}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Paper>
        ))}
      <AddInstructionsModal
        show={showAddModal}
        onClose={() => {
          setShowAddModal(false);
          setActiveEditData(null);
        }}
        recipient={recipient}
        refetch={refetch}
        activeEditData={activeEditData}
      />
    </Grid>
  );
};

export default Instructions;
